import { assistedAffiliationClient } from "./assistedAffiliationClient";
import { getAssistedAffiliationHost } from "./getAssistedAffiliationHost";
import { ApiEnvelope, AssistedAffiliationDraft } from "./types";

const assistedAffiliationDraftEndpoint = "/v1/assisted-affiliation/draft";

/**
 * La solicitud completa: todo lo que el servicio guarda de ella, incluidos los campos que el
 * listado no trae y los que el formulario no muestra.
 * @param documentNumber - Identificador con el que el endpoint resuelve el registro. La fila del
 * listado trae además `id` y `registryNumber`, que este endpoint NO acepta.
 * @returns El contenido de `data`; relanza el error para que la pantalla lo traduzca.
 */
export const getAssistedAffiliationDraftService = async (
  documentNumber: string
): Promise<AssistedAffiliationDraft> => {
  const host = await getAssistedAffiliationHost();

  const response = await assistedAffiliationClient.get<
    ApiEnvelope<AssistedAffiliationDraft>
  >(`${host}${assistedAffiliationDraftEndpoint}/${documentNumber}`);

  // El envoltorio se abre aquí, igual que en el listado, para que la pantalla nunca lo vea.
  return response.data.data;
};
